import "../../styles/familymember.css";
import FamilySelectClient from "./FamilySelectClient";
import FamilyHome from "./FamilyHome";
import FamilyChecklist from "./FamilyChecklist";
import FamilyVitals from "./FamilyVitals";
import FamilySettings from "./FamilySettings";
import FamilyResetPassword from "./FamilyResetPassword";

export const familyMemberRoutes = [
  { path: "/family-select-client", element: <FamilySelectClient /> },
  { path: "/family-home", element: <FamilyHome /> },
  { path: "/family-checklist", element: <FamilyChecklist /> },
  { path: "/family-vitals", element: <FamilyVitals /> },
  { path: "/family-settings", element: <FamilySettings /> },
  { path: "/family-reset-password", element: <FamilyResetPassword /> },
];

export const FAMILY_MEMBER_PATHS = familyMemberRoutes.map((route) => route.path);
